import InfoTooltip from "components/Popup/InfoTooltip";
import { IConcreteBaseFinancials } from "Dashboard/scenes/Projects/domain/IConcreteBaseFinancials";
import { useAppDispatch } from "hooks/hooks";
import { useSelector } from "react-redux";
import { FormatDateShort } from "utils/dateUtils";
import { FormatNumber, FormatNumberWithUnitOrNull } from "utils/numberUtils";
import { getBuildingConcreteBaseFinancials, selectState } from "../financials.slice";
import { useEffect, useState } from "react";
import ConcreteBaseItemSelectCreate from "Dashboard/scenes/ConcreteBase/scenes/Input/components/ConcreteBaseItemSelectCreate";
import { styles } from "../../../../Projects/scenes/Financials/components/SelectStatisticsStyle";

interface IProps {
  buildingId: number;
  data: IConcreteBaseFinancials | undefined;
}

const ConcreteBaseOwnProducts = ({ buildingId, data }: IProps) => {
  const dispatch = useAppDispatch();

  const { selectedDateFrom, selectedDateTo } = useSelector(selectState);
  const [itemId, setItemId] = useState();

  useEffect(() => {
    if (buildingId) {
      setItemId(undefined);
    }
  }, [buildingId]);

  useEffect(() => {
    if (buildingId) {
      dispatch(getBuildingConcreteBaseFinancials({
        buildingId,
        from: selectedDateFrom,
        to: selectedDateTo,
        concreteBaseItemId: itemId
      }));
    }
  }, [
    dispatch,
    buildingId,
    selectedDateFrom,
    selectedDateTo,
    itemId
  ]);

  return (
    <div>
      <h3><strong>BETON</strong></h3>
      <section>
        <div className="buildings-box-header concrete-base-box">
          <div>
            <span className="right-align">suma</span>
            <span className="strong-txt center-align txt-underline">
              {FormatNumberWithUnitOrNull(data?.concreteQuantityTotal, "m3")}
            </span>
            <span className="strong-txt center-align txt-underline">
              {FormatNumberWithUnitOrNull(data?.costAmountTotal, "rsd")}
            </span>
          </div>
          <div>
            <span className="right-align">projekti</span>
            <span className="strong-txt center-align txt-underline">
              {FormatNumberWithUnitOrNull(data?.concreteQuantityProjects, "m3")}
            </span>
            <span className="strong-txt center-align txt-underline">
              {FormatNumberWithUnitOrNull(data?.costAmountProjects, "rsd")}
            </span>
          </div>
        </div>
        <div style={{ marginRight: "15px" }}>
          <ConcreteBaseItemSelectCreate
            key={buildingId}
            onChange={setItemId}
            customStyles={styles.customStyleClassic}
          />
        </div>
        <div className="buildings-box-content">
          <div className="list-wrapp">
            {data?.entries &&
              data.entries.map((entry, index) => (
                <article key={index}>
                  <div className="col-1">
                    <span className="left strong">{entry.itemName}</span>
                  </div>
                  <div>
                    <span className="box-span right">
                      {entry.quantityAmount} {entry.quantityUnit.name}
                    </span>
                    <span className="light-color">izdato</span>
                    <span className="box-span">
                      {FormatDateShort(entry.date)}
                    </span>
                  </div>
                  <div>
                    <span className="box-span right">
                      {FormatNumber(entry.pricePerUnit)} rsd
                    </span>
                    <InfoTooltip
                      tooltip={entry.note}
                      classesProp="light-color grid-span-2 bg-text-overflow"
                      element="span"
                    >
                      cena &nbsp;&nbsp; {entry.note}
                    </InfoTooltip>
                  </div>
                </article>
              ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ConcreteBaseOwnProducts;
